import { configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/userReducer';
import leadReducer from './reducers/leadReducer';
import masterDataReducer from './reducers/masterDataReducer'
import { loadStateFromLocalStorage, saveStateToLocalStorage } from './localStorage';
import masterDataUCRFReducer from './reducers/masterDataReducerUCRF';

const persistedState = loadStateFromLocalStorage();

const store = configureStore({
  reducer: {
    user: userReducer,
    lead: leadReducer,
    masterdata: masterDataReducer,
    masterdataucrf: masterDataUCRFReducer
  },
  preloadedState: persistedState,
});

window.addEventListener('beforeunload', () => {
  saveStateToLocalStorage(store.getState());
});


export default store;